module.exports = __webpack_public_path__ + "img/lens-167-plus-05.5e082cf2.png";